import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'

import styles from './ChipsGroup.module.scss'

export const ChipsGroup = ({ chips, className }) => (
  <Box
    className={cx(styles.chips, { [className]: Boolean(className) })}
    tagName="span"
    shouldWrapContent
  >
    {chips.map(text => (
      <span className={styles.chip} key={text}>
        {text}
      </span>
    ))}
  </Box>
)
